import { OFFERTE_STATUSES, OFFERTE_OPEN_STATUSES, OFFERTE_CLOSED_STATUS } from './offerte-status';

// Status-bron is offerte-status.ts (SSOT). Deze re-exports blijven voor bestaande
// consumers (OffertesPage, OfferteDetailView) — geen eigen waarheid meer hier.
export const LEAD_STATUS_COLORS: Record<string, string> = {
  ...Object.fromEntries(OFFERTE_STATUSES.map((s) => [s.value, s.color])),
  'Offerte Akkoord': 'bg-emerald-100 text-emerald-700',
};

export const PACKAGE_SKUS = [
  'WAS-PACK-VLOERKLEED-BASIS',
  'WAS-PACK-VLOERKLEED-PROTECT',
  'WAS-PACK-VLOERKLEED-PET',
  'WAS-PACK-VLOERKLEED-PREMIUM',
] as const;

export type PackageSku = typeof PACKAGE_SKUS[number];

export const PACKAGE_LABELS: Record<PackageSku, string> = {
  'WAS-PACK-VLOERKLEED-BASIS': 'Basis',
  'WAS-PACK-VLOERKLEED-PROTECT': 'Reiniging & Protect',
  'WAS-PACK-VLOERKLEED-PET': 'Huisdier',
  'WAS-PACK-VLOERKLEED-PREMIUM': 'Premium',
};

export const POPULAR_PACKAGE_SKU: PackageSku = 'WAS-PACK-VLOERKLEED-PROTECT';

export const KLEDA_OPEN_STATUSES = OFFERTE_OPEN_STATUSES;

export const LEAD_CLOSED_STATUS = OFFERTE_CLOSED_STATUS;
